import { createEvent, sample } from 'effector'
import { RecalcForm } from './types'
import { fx } from '../../../libs'

export const recalculateBalanceEvent = createEvent<RecalcForm>()
export const recalculateBalance = fx<RecalcForm, void>({
  method: 'POST',
  url: `/finance/wallet/recalculate`,
})

sample({
  clock: recalculateBalanceEvent,
  fn: (recalcData) => {
    return {
      body: {
        ...recalcData,
      },
    }
  },
  target: recalculateBalance,
})
